import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rp-home-statistics-detailing-schema',
  standalone: true,
  templateUrl: './statistics-detailing-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class StatisticsDetailingSchemaComponent {}
